import { render, staticRenderFns } from "./FuncionalidadeHandler.vue?vue&type=template&id=a27e00ae&scoped=true"
import script from "./FuncionalidadeHandler.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeHandler.vue?vue&type=script&lang=js"
import style0 from "./FuncionalidadeHandler.vue?vue&type=style&index=0&id=a27e00ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27e00ae",
  null
  
)

export default component.exports